export default __webpack_public_path__ + "assets/images/icon-success.29884a649398a4ad6091efd5d96606a2.svg";